module.exports = __webpack_public_path__ + "static/media/G1-4-Heleen-Herod-cod24.058e8ed2.png";